import CnpjValidate from './cnpj'
const validator = {
  getMessage(field, args) {
    return 'CNPJ inválido'
  },
  validate(value, args) {
    return CnpjValidate(value)
  }
}
export default validator
